module.exports = __webpack_public_path__ + "static/premium-6-dolares-signos-negros-60c79f05f140c5e75f7db641d1e98e95.png";